<template>
	<div class="container">
		<div class="main">
			<div class="content">
				<!-- 顶部搜索及tab -->
				<div class="box-search content-inner">
					<el-input
						class="nav-search-l"
						placeholder="大家都在搜"
						prefix-icon="el-icon-search"
						:select-when-unmatched="true"
						@keyup.enter.native="getDataAll"
						v-model="searchValue">
					</el-input>
					<el-tabs v-model="activeNameType" @tab-click="handleClickType" class="custom-tabs ">
						<el-tab-pane label="综合" name="1"></el-tab-pane>
						<el-tab-pane label="帖子" name="2"></el-tab-pane>
						<el-tab-pane label="圈子" name="3"></el-tab-pane>
						<el-tab-pane label="用户" name="4"></el-tab-pane>
						<el-tab-pane label="问答" name="5"></el-tab-pane>
						<el-tab-pane label="话题" name="6"></el-tab-pane>
					</el-tabs>
				</div>
				<!--综合-->
				<div class="">
					<!-- 帖子 -->
					<div class="content-inner mt-2" v-if="(activeNameType == 1 || activeNameType == 2) && listPost.length">
						<div class="title-all">
							<div class="">帖子</div>
							<div class="txt-more" v-if="activeNameType == 1" @click="getDataAllMore('2')">更多<span class="el-icon-caret-right"></span></div>
						</div>
						<div v-for="(item,_index) in listPost"  :key="_index">
							<articleCard :item="item"  :type="item.categoryScene"/>	
						</div>
						<Pagination v-if="activeNameType != 1"  :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
					</div>
					<!-- 圈子 -->
					<div class="content-inner mt-2" v-if="(activeNameType == 1 || activeNameType == 3) && listCircle.length">
						<div class="title-all">
							<div class="">圈子</div>
							<div class="txt-more" v-if="activeNameType == 1" @click="getDataAllMore('3')">更多<span class="el-icon-caret-right"></span></div>
						</div>
						<div v-for="(item,index) in listCircle"  :key="index" class="item-circle">
							<div class="item-l">
								<div class="circle-list" @click="toCircleIndex(item.id)">
									<div class="circle-list-l">
										<img :src="item.icon||require('@/assets/default-img.png')"/>
									</div>
									<div class="circle-list-r">
										<h3 >{{item.circleName}}</h3>
										<div class="circle-num">{{item.postNum}}帖子</div>
									</div>
								</div>
							</div>
							<div class="item-r">
								<el-button size="mini" round v-if="item.isJoin == 0" @click="toEnter(item)">加入</el-button>
								<el-button size="mini" round v-else>已加入</el-button>
							</div>
						</div>
						<Pagination v-if="activeNameType != 1"  :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
					</div>
					<!-- 用户 -->
					<div class="content-inner mt-2" v-if="(activeNameType == 1 || activeNameType == 4) && listUser.length">
						<div class="title-all">
							<div class="">用户</div>
							<div class="txt-more" v-if="activeNameType == 1" @click="getDataAllMore('4')">更多<span class="el-icon-caret-right"></span></div>
						</div>
						<div v-for="(item,index) in listUser"  :key="index" class="item-user mt-2">
							<div class="item-l">
								<div class="userinfo" @click="toDetail(item.id)">
									<div class="userinfo-l">
										<img :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
									</div>
									<div class="userinfo-r">
										<div class="username-wrap">
											<div class="username">{{ item.nickName }}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="item-r">
								<el-button size="mini" round v-if="item.isFollow == 0" @click="toFollow(item)">关注</el-button>
								<el-button size="mini" round v-else @click="toFollow(item)">已关注</el-button>
							</div>
						</div>
						<Pagination v-if="activeNameType != 1"  :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
					</div>
					<!-- 问答 -->
					<div class="content-inner mt-2" v-if="(activeNameType == 1 || activeNameType == 5) && listQuestion.length">
						<div class="title-all">
							<div class="">问答</div>
							<div class="txt-more" v-if="activeNameType == 1" @click="getDataAllMore('5')">更多<span class="el-icon-caret-right"></span></div>
						</div>
						<div v-for="(item,_index) in listQuestion"  :key="_index">
							<!-- 回答类型 -->
							<questions :item="item"/>
						</div>
						<Pagination v-if="activeNameType != 1"  :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
					</div>
					<!-- 话题 -->
					<div class="content-inner mt-2" v-if="(activeNameType == 1 || activeNameType == 6) && listTalk.length">
						<div class="title-all">
							<div class="">话题</div>
							<div class="txt-more" v-if="activeNameType == 1" @click="getDataAllMore('6')">更多<span class="el-icon-caret-right"></span></div>
						</div>
						<div v-for="(item,_index) in listTalk"  :key="_index" @click="toTalkPost(item.id)">
							<!-- 回答类型 -->
							<div class="item-talk mt-2">
								<div class="title-talk">#{{item.categoryName}}</div>
								<div class="count">{{item.hotNum}}人热议</div>
							</div>
						</div>
						<Pagination v-if="activeNameType != 1"  :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
					</div>
				</div>
			</div>
			<div class="aside">
				<asideNews/>
				<asideCircle/>
				<asideFollow/>
			</div>
		</div>
	</div>
</template>

<script>
	import asideNews from '@/components/aside/news'
	import asideCircle from '@/components/aside/recommendCircle'
	import asideFollow from '@/components/aside/recommendFollow'
	import Pagination from '@/components/pagination'
	import articleCard from '@/components/articleCard'
	import questions from '@/components/questions'
	
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'circleIndex',
		components: {
			asideNews,
			asideCircle,
			asideFollow,
			Pagination,
			articleCard,
			questions
		},
		data(){
			return {
				activeTab: 'all',
				circleId: '',
				userId: '',
				circleModel: {},
				sortType: 0, //0最新互动 1最新 2热门
				sortFlag: 0, //0倒叙 1正序
				pageSize:10,
				pageNum: 1,
				categoryId: '',
				topPost: [],
				value: 0,
				sortQuestion:1,
				searchValue: '',
				activeNameType: '1',
				listPost: [],
				listCircle: [],
				listUser: [],
				listTalk: [],
				listQuestion: [],
				total: 0
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.searchValue = this.$route.query.searchValue
			this.getDataAll()
			
		},
		watch:{
			'$route'(to, from) {
				// 监听路由变化，重新获取参数并刷新
				this.searchValue = to.query.searchValue;
				this.pageNum = 1;
				this.getDataAll();
			}
		},
		methods: {
			toDetail(id){
				this.$router.push({
					path: '/userIndex?id='+id
				})
			},
			// tab切换
			handleClickType(){
				this.pageNum = 1
				this.getDataAll()
			},
			//获取数据列表
			getDataAllMore(type) {
				if(type) {
					this.activeNameType = type
				}
				this.pageNum = 1
				this.getDataAll()
			},
			async getDataAll(){
				let param = {
					userId: this.userId,
					mainSearch: this.searchValue,
					searchType:this.activeNameType
				}
				if(this.activeNameType != 1) {
					param.pageSize = this.pageSize
					param.pageNum = this.pageNum
				}
				ajaxParam(param)
				const res = await post('v1/circle/mainSearch', qs.stringify(param))
				if (res.data.code == 200) {
						console.log(res.data)
						let obj = res.data
						this.listPost = obj.postList
						this.listCircle = obj.circleList
						this.listUser = obj.userList
						this.listTalk = obj.talkList
						this.listQuestion = obj.questionList
						this.total = res.data.total
				} else {
						this.$message.error(res.data.msg)
				}
		},
		// 分页
		pageChange(e) {
				this.listPost = []
				this.pageNum = e.number
				this.getDataAll()
		},
		toCircleIndex(id){
			this.$router.push({
				path: '/circleIndex?id='+id
			})
		},
		toTalkPost(id) {
			this.$router.push({
				path: '/talkPostList?id='+id
			})
		},
		// 点击加入圈子
		async toEnter(item) {
			if (!this.userId) {
					this.$router.push({
							path: '/login'
					})
					return
			}
			let param = {
					userId: this.userId,
					circleId: item.id,
					circleIds: ''
			}
			ajaxParam(param)
			const res = await post('v1/circle/joinCircle', qs.stringify(param))
			if (res.data.code == 200) {
					console.log(res.data)
					this.$message.success('加入成功！')
					this.getDataAll()
					this.item.isJoin = 1
					this.visible = true
			} else {
						this.$message.error(res.data.msg)
				}
			},
			//关注 取消关注
			async toFollow(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					followUserId: item.id,
					followFlag: item.isFollow==1?0:1
				}
				ajaxParam(param)
				const res = await post('v1/circle/followUser', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					if(item.isFollow==1) {
						this.$message.success('取消关注成功！')
					} else {
						this.$message.success('关注成功！')
					}
					item.isFollow = item.isFollow==1?0:1
					
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.main{
		display: flex;
		justify-content: space-between;
		width: 1180px;
		margin: 20px auto;
		.content{
			flex: 1;
			// background: #fff;
			// padding: 40px;
			// border-radius: 10px;
		}
		.lable-select{
			width: 100px;
		}
		.aside{
			width: 300px;
			margin-left: 20px;
		}
		.content-inner{
			position: relative;
			background: #fff;
			padding: 10px 40px 20px;
			border-radius: 10px;
			.sort-wrap{
				position: absolute;
				right: 40px;
				top: 10px;
				display: flex;
				align-items: center;
				// width: 198px;
				height: 32px;
				background: #F3F4F7;
				border-radius: 4px;
				justify-content: space-around;
				z-index: 999;
				span{
					display: block;
					width: 62px;
					height: 28px;
					border-radius: 4px;
					text-align: center;
					line-height: 28px;
					cursor: pointer;
					font-size: 12px;
				}
				span.active{
					background: #fff;
				}
			}
			/deep/ .el-tabs__item{
				height: 42px;
				line-height: 42px;
			}
			/deep/ .el-tabs__active-bar{
				background-color: #DD0515;
			}
			/deep/ .el-tabs__item.is-active{
				color: #DD0515;
			}
			/deep/ .el-tabs__item:hover{
				color: #DD0515;
			}
		}
		.questions-wrap-inner{
			width: 100%;
			display: flex;
			justify-content: end;
			align-items: center;
			margin-bottom: 20px;
		}
		.suggestion-wrap{
			width: 100%;
			.lable-select{
				margin-right: 10px;
			}
		}
		.questions-wrap{
			display: flex;
			align-items: center;
			width: 198px;
			height: 32px;
			background: #c4c4c4;
			border-radius: 4px;
			justify-content: space-around;
			z-index: 999;
			color: #fff;
			span{
				display: block;
				width: 100%;
				height: 32px;
				border-radius: 4px;
				text-align: center;
				line-height: 32px;
				cursor: pointer;
				font-size: 12px;
			}
			span.active{
				background: #f04444;
			}
		}
	}
	.nav-search-l {
		/deep/input::-webkit-input-placeholder{
			-webkit-text-fill-color: #999;
		}
		//修改输入框字体颜色
		.el-input /deep/ .el-input__inner {
			color: #999;
		}
		:deep(.el-input__prefix) {
		.el-icon-search {
			color:  #999;
			margin-top: 2px;
			text-align: center;
		}
		}
	}
	.custom-tabs {
		margin-top: 10px;
		:deep(.el-tabs__nav-wrap::after) {
			display: none;
		}
		:deep(.el-tabs__active-bar){
			display: none;
		}
		:deep .el-tabs__item:focus {
			outline: none !important;
			box-shadow: none !important;
		}
	}
	.title-all{
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		font-size: 22px;
		color:#333;
		.txt-more{
			font-size: 14px;
			color: #666;;
			cursor: pointer;
		}
	}
	.item-circle{
		display: flex;
		justify-content: space-between;
		.circle-list{
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			padding: 0 10px;
			cursor: pointer;
			box-sizing: border-box;
			.circle-list-l{
				position:relative;
				.icon-circle{
					width:14px;
					height: 14px;
					background: #DD0515;
					border-radius: 50%;
					line-height: 14px;
					text-align: center;
					font-size: 12px;
					color:#fff;
					position: absolute;
					right: 0;
					top: 0
				}
				img{
					width: 50px;
					height: 50px;
					margin: 0 auto;
					border-radius: 15px;
				}
			}
			.circle-list-r{
				margin-left: 10px;
				overflow: hidden;
				h3{
					width: 100%;
					font-size: 14px;
					font-weight: bold;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					text-align: center;
					line-height: 30px;
				}
				.circle-num{
					margin: 4px 0 10px;
					opacity: .7;
					font-size: 12px;
				}
			}
		}
	}
	.item-user{
		display: flex;
		justify-content: space-between;
		cursor: pointer;
		.userinfo {
			display: flex;
			align-items: center;
			.userinfo-l img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}

			.userinfo-r {
				margin-left: 10px;

				.username-wrap {
					display: flex;
					align-items: center;

					.username {
						font-size: 16px;
						font-weight: bold;
					}
				}

				.user-type {
					display: inline-block;
					height: 18px;
					padding: 0 4px!important;
					background: rgba(247, 125, 42, .18);
					border-radius: 4px;
					color: #F77D2A;
					font-size: 12px;
					line-height: 18px;
					text-align: center;
					margin-top: 2px;
				}

				.level{
					margin-left:5px;
					img{
						height:16px;
						margin-top: 0;
					}
				}

				.userinfo-tips {
					margin-top: 2px;
					opacity: .7;
					font-size: 12px;
					cursor: pointer;
				}
			}
		}
	}
	.item-talk{
		font-size: 16px;
		color: #333;
		cursor: pointer;
		.count{
			font-size: 12x;
			color: #999;
		}
	}
	.item-r button{
		width:58px !important;
		height: 24px !important;
		line-height: 24px !important;
		font-size: 12px !important;
		padding: 0
	}
</style>
<style>

.custom-tabs .el-tabs__nav{
	left: 50%;
	margin-left: -25%;
}
.nav-search-l{
	text-align: center;
}
.nav-search-l input{
	width: 800px;
	height: 40px;
	background: #E0E0E0;
	border-radius: 30px;
	color:#888;
	border-color: transparent !important;
	text-align: center !important;
}
.nav-search-l .el-input__icon{
	line-height: 40px !important;
	margin-left: 10px;
	font-size: 18px;
	color:#888;
}
.nav-search-l .el-input__inner:focus{
	background: #E0E0E0 !important;
	border-color:transparent !important;
}

.nav-search-l .el-input__inner::placeholder {
  color:  #5E5E5E;
}
</style>